import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { apiUrl} from'../Config/Config';
import axios from 'axios';
/* import { GET_DASHBOARDLIST  } from '../../actions'; */

class List extends Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
      dashboardlist:'',
      totalRecordUsers:0,
      totalRecordvehicles:0,
      totalRecorddrivers:0,
      totalRecordCompanies:0,
      totalRecordAdmin:0,
      totalRecordCoupon:0,
      totalRecordAds:0,
      totalRecordPopularcity:0,
      totalRecordMenus:0,
      totalRecordFonts:0,
      totalRecordTemplates:0,
    };
    
    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var loggedas = localStorage.getItem("loggedas");
    var postobject = {
    activePage: 1,
    search_all: '',
    admin_id: admin_id,
    loggedas: loggedas
    };

    axios.post(apiUrl+"dashboard/list",qs.stringify(postobject)).then(res => {
     
      if(res.data.status === 'success'){
        this.setState({ 
          totalRecordUsers : res.data.records_count_users,
          totalRecordCompanies : res.data.records_count_company,
          totalRecordvehicles : res.data.records_count_vehicle,
          totalRecorddrivers : res.data.records_count_drivers,
          totalRecordAdmin : res.data.records_count_admin,
          totalRecordCoupon : res.data.records_count_coupon,
          totalRecordAds : res.data.records_count_ads,
          totalRecordPopularcity : res.data.records_count_popularcity,
          totalRecordMenus : res.data.records_count_menu,
          totalRecordFonts : res.data.records_count_font,
          totalRecordTemplates : res.data.records_count_template,
          });
      }
    }); 

    }

   
    componentDidMount() {
   }




  render() {
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="dashboard" currentTab="car" />
      
      <div className="content"> 
        <div className="content-wrapper">
              <div class="content-wrapper-before"></div>
              <div className="car-listing-wrap dashboard-wrap leaa-admin-head card">

                  <div className="title">
                    <h3>Dashboard</h3>
                  </div>

                  <div className="form-row first">
                    {localStorage.getItem('admin_id') === '1' ?  <div className="form-left">
                      <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                        <div className="card-header">
                            <h4 className="card-title card-badge card-title-black ">{this.state.totalRecordCompanies}</h4>
                        </div>
                        <a href="/company" className="">
                          <div className="card-content collapse show">
                              <div className="card-body p-1">
                                  <h4 className="fs-4 text-bold-400 px-4">Companies<i className="fa fa-building float-right"></i></h4>
                              </div>
                              <div className="card-footer p-1">
                              </div>
                          </div>
                        </a>
                      </div>
                    </div>: ''}                   
                    <div className="form-right">
                      <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                        <div className="card-header">
                          <h4 className="card-title card-badge card-title-black">{this.state.totalRecordAdmin}</h4>
                        </div>
                        <a href="/pluginowner" className="">
                          <div className="card-content collapse show">
                              <div className="card-body p-1">
                                  <h4 className="fs-4 text-bold-400 px-4">Admin <i className="float-right">
                                    <svg width={'30'} xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="2.39 3.7 95.03 92.3"><g><path d="M49.8,53.2l4.7-4.7c0.2-0.2,0.4-0.4,0.6-0.5c-2.7-3.8-6.5-6.8-10.9-8.5c-3.5,2.3-7.8,3.7-12.3,3.7s-8.8-1.4-12.3-3.7   c-6.4,2.5-11.6,7.7-14,14.4c-1.7,4.8-2.8,9.9-3.2,15c-0.2,2.3,1.7,4.3,4.1,4.3h36.9v-4.6c0-3.3,2.3-6.1,5.5-6.7   C47.2,59.2,47.5,55.5,49.8,53.2z"></path><path d="M31.9,37.7c9.4,0,17-7.6,17-17c0-9.4-7.6-17-17-17s-17,7.6-17,17C15,30.1,22.6,37.7,31.9,37.7z"></path><path d="M96.3,67.2l-4.6-0.5c-0.4-1.5-1-2.9-1.7-4.2l2.9-3.6c0.4-0.5,0.4-1.3-0.1-1.8L88,52.4c-0.5-0.5-1.3-0.5-1.8-0.1l-3.6,2.9   c-1.3-0.7-2.7-1.3-4.2-1.7l-0.5-4.6c-0.1-0.7-0.7-1.2-1.4-1.2h-6.6c-0.7,0-1.3,0.5-1.4,1.2L68,53.4c-1.5,0.4-2.9,1-4.2,1.7   l-3.6-2.9c-0.5-0.4-1.3-0.4-1.8,0.1l-4.7,4.7c-0.5,0.5-0.5,1.3-0.1,1.8l2.9,3.6c-0.7,1.3-1.3,2.7-1.7,4.2l-4.6,0.5   c-0.7,0.1-1.2,0.7-1.2,1.4v6.6c0,0.7,0.5,1.3,1.2,1.4l4.6,0.5c0.4,1.5,1,2.9,1.7,4.2l-2.9,3.6c-0.4,0.5-0.4,1.3,0.1,1.8l4.7,4.7   c0.5,0.5,1.3,0.5,1.8,0.1l3.6-2.9c1.3,0.7,2.7,1.3,4.2,1.7l0.5,4.6c0.1,0.7,0.7,1.2,1.4,1.2h6.6c0.7,0,1.3-0.5,1.4-1.2l0.5-4.6   c1.5-0.4,2.9-1,4.2-1.7l3.6,2.9c0.5,0.4,1.3,0.4,1.8-0.1l4.7-4.7c0.5-0.5,0.5-1.3,0.1-1.8l-2.9-3.6c0.7-1.3,1.3-2.7,1.7-4.2   l4.6-0.5c0.7-0.1,1.2-0.7,1.2-1.4v-6.6C97.5,67.9,97,67.3,96.3,67.2z M73.2,81.3c-5.2,0-9.4-4.2-9.4-9.4s4.2-9.4,9.4-9.4   c5.2,0,9.4,4.2,9.4,9.4S78.4,81.3,73.2,81.3z"></path></g></svg>
                                    </i></h4>
                              </div>
                              <div className="card-footer p-1">
                              </div>
                          </div>
                        </a>
                      </div>
                    </div>  
                    
                  </div> 

                    <div className="form-row ">
                      <div className="form-left">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                              <h4 className="card-title card-badge card-title-black">{this.state.totalRecordUsers}</h4>
                          </div>
                          <a  href="/user" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="fs-4 text-bold-400 px-4">Users <i className="fa fa-users float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="form-right">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge card-title-black">{this.state.totalRecorddrivers}</h4>
                          </div>
                          <a href="/drivers" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="fs-4 text-bold-400 px-4">Drivers <i className=" float-right">
                                      <svg width={'30'} xmlns="http://www.w3.org/2000/svg" fill="none" x="0px" y="0px" viewBox="3 5 26 21"><path d="M17 10C17 12.7614 14.7614 15 12 15C9.23858 15 7 12.7614 7 10C7 7.23858 9.23858 5 12 5C14.7614 5 17 7.23858 17 10Z" fill="black"></path><path d="M15.2137 17.1554C15.0739 17.7476 15 18.3652 15 19C15 21.4075 16.0634 23.5666 17.7462 25.0332C16.7311 25.6468 15.541 26 14.2683 26H9.73169C6.01388 26 3 22.9861 3 19.2683C3 18.876 3.20566 18.5156 3.56615 18.3608C4.65194 17.8945 7.34197 17 12 17C13.1997 17 14.2689 17.0593 15.2137 17.1554Z" fill="black"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M29 19C29 22.3137 26.3137 25 23 25C19.6863 25 17 22.3137 17 19C17 15.6863 19.6863 13 23 13C26.3137 13 29 15.6863 29 19ZM24.8546 19.75H26.9298C26.6248 21.3577 25.3577 22.6248 23.75 22.9298V20.8546C24.2514 20.6517 24.6517 20.2513 24.8546 19.75ZM24.8546 18.25H26.9298C26.5787 16.3994 24.9528 15 23 15C21.0472 15 19.4213 16.3994 19.0702 18.25H21.1454C21.4421 17.517 22.1607 17 23 17C23.8393 17 24.5579 17.517 24.8546 18.25ZM21.1454 19.75H19.0702C19.3752 21.3577 20.6423 22.6248 22.25 22.9298V20.8546C21.7486 20.6517 21.3483 20.2513 21.1454 19.75Z" fill="black"></path></svg>
                                      </i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                          </a>
                        </div>
            					</div>                                 					
            				</div>
                    <div className="form-row ">
            					<div className="form-left">            					
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge card-title-black">{this.state.totalRecordvehicles}</h4>
                            </div>
                              <a href="/vehicle" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="fs-4 text-bold-400 px-4">Vehicles<i className=" float-right">
                                          <svg width="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M604.58 315.56L600 304.2l-17.87-49.08a99.92 99.92 0 0 0-93.2-63.12H375.07a99.92 99.92 0 0 0-93.23 63.12L264 304.2l-4.55 11.36a57.39 57.39 0 0 0-35.42 53v28.69a57 57 0 0 0 21.52 44.46V480a32 32 0 0 0 32 32h22.07a32 32 0 0 0 32-32v-32h200.79v32a32 32 0 0 0 32 32h22.07a32 32 0 0 0 32-32v-38.3A57 57 0 0 0 640 397.24v-28.69a57.39 57.39 0 0 0-35.42-52.99zM335.11 284c6.53-16.92 22.36-28 40-28h113.82c17.6 0 33.42 11.1 40 28L541 320H323zM300 407.85c-14.4 0-24-9.57-24-23.92S285.6 360 300 360s36 21.53 36 35.89-21.6 11.96-36 11.96zm264 0c-14.4 0-36 2.39-36-12S549.6 360 564 360s24 9.57 24 23.93-9.6 23.92-24 23.92zM252.12 243.23a134.44 134.44 0 0 1 9.65-19.23H192V80h81.33A14.67 14.67 0 0 1 288 94.67v98.07a131.26 131.26 0 0 1 64-30.56V62.86C352 27.66 274.06 0 176 0S0 27.66 0 62.86v259.81A29.33 29.33 0 0 0 29.33 352H40v32a32 32 0 0 0 32 32h23.17a32 32 0 0 0 32-32v-32h67c4.63-24.49 18.73-46.08 40-59.29zM80 312a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm80-88H78.67A14.67 14.67 0 0 1 64 209.33V94.67A14.67 14.67 0 0 1 78.67 80H160z"></path></svg>
                                          </i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div>   
            					</div>                     
            					<div className="form-right">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge card-title-black">{this.state.totalRecordCoupon}</h4>
                          </div>
                          <a href="/coupon" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="fs-4 text-bold-400 px-4">Coupons <i className="fa-tags fa float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                          </a>
                        </div>
            					</div>  
            				</div>
                    

                    {/* -------------- */}
                   <div className="form-row ">
            					<div className="form-left">
            					
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge card-title-black">{this.state.totalRecordAds}</h4>
                            </div>
                              <a href="/advertisement" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="fs-4 text-bold-400 px-4">Advertisements<i className=" float-right">
                                          <svg width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="15 18.4 69.95 62.99">  <path d="m16.699 55.898c0.69922 3.6992 3.8984 6.3008 7.6016 6.3008 0.5 0 0.89844 0 1.3008-0.10156l15.898-2.8984c0.39844-0.10156 26.102 7.6992 26.102 7.6992 0.19922 0.10156 0.39844 0.10156 0.59766 0.10156 0.39844 0 0.69922-0.10156 1-0.39844 0.39844-0.39844 0.60156-0.89844 0.5-1.5l-8.1016-45.398c-0.10156-0.5-0.5-1-1-1.1992-0.5-0.19922-1.1016-0.10156-1.5 0.30078 0 0-21.398 16.199-21.801 16.199l-15.898 2.9961c-2 0.39844-3.8008 1.5-5 3.1992-1.1992 1.6992-1.6016 3.6992-1.3008 5.8008zm2.1016-13c0.69922-1 1.8008-1.6992 3-2 0.5-0.10156 1.1016 0.30078 1.1992 0.80078 0.10156 0.5-0.30078 1.1016-0.80078 1.1992-0.69922 0.10156-1.3008 0.5-1.8008 1.1016-0.39844 0.60156-0.60156 1.3008-0.39844 2l0.5 2.6992c0.10156 0.60156-0.30078 1.1016-0.80078 1.1992h-0.19922c-0.5 0-0.89844-0.30078-1-0.80078l-0.5-2.6992c-0.10156-1.2969 0.10156-2.5 0.80078-3.5z"></path>  <path d="m35.898 63.398-5.3008 0.89844-3.1016 0.60156 4.8008 11.699c1.1992 3 3.6992 4.8008 6.3984 4.8008 0.30078 0 0.60156 0 1-0.10156l4.6016-0.80078c0.5-0.10156 0.89844-0.39844 1.1016-0.80078 0.19922-0.39844 0.30078-0.89844 0.10156-1.3008l-6.5-15.496z"></path>  <path d="m71.602 43h0.30078l10-1.8008c0.80078-0.19922 1.3984-1 1.1992-1.8008-0.19922-0.80078-1-1.3984-1.8008-1.1992l-10 1.8008c-0.80078 0.19922-1.3984 1-1.1992 1.8008 0.19922 0.59766 0.79688 1.1992 1.5 1.1992z"></path>  <path d="m73.398 52.398c-0.80078-0.19922-1.6992 0.19922-1.8984 1.1016-0.19922 0.80078 0.19922 1.6992 1.1016 1.8984l10.398 2.9023c0.10156 0 0.30078 0.10156 0.39844 0.10156 0.69922 0 1.3008-0.39844 1.5-1.1016 0.19922-0.80078-0.19922-1.6992-1.1016-1.8984z"></path>  <path d="m78.602 21.898c-0.5-0.69922-1.5-0.80078-2.1992-0.30078l-8.8008 6.4023c-0.69922 0.5-0.80078 1.5-0.30078 2.1992 0.30078 0.39844 0.80078 0.60156 1.3008 0.60156 0.30078 0 0.60156-0.10156 0.89844-0.30078l8.8008-6.3984c0.69922-0.5 0.80078-1.5 0.30078-2.2031z"></path> </svg>
                                          </i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div>   
            					</div>
                     
            					 <div className="form-right">
                         <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                            <div className="card-header">
                            <h4 className="card-title card-badge card-title-black">{this.state.totalRecordPopularcity}</h4>
                             </div>
                              <a href="/popularcity" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="fs-4 text-bold-400 px-4">Popular City <i className="fa-fire fa float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                            </a>
                          </div>
            					  </div> 
            				</div>
                    <div className="form-row ">
                      <div className="form-left">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                              <h4 className="card-title card-badge card-title-black">{this.state.totalRecordMenus}</h4>
                          </div>
                          <a  href="/dashboardmanagement" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="fs-4 text-bold-400 px-4">Menu Management <i className="fa fa-list-ul float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="form-right">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge card-title-black">{this.state.totalRecordFonts}</h4>
                          </div>
                          <a href="/fonts" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="fs-4 text-bold-400 px-4">Fonts <i className="fa fa-font float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                          </a>
                        </div>
            					</div>                                 					
            				</div>
                    <div className="form-row ">
            					<div className="form-left">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge card-title-black">{this.state.totalRecordTemplates}</h4>
                            </div>
                              <a href="/templates" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="fs-4 text-bold-400 px-4">Templates<i className="float-right">
                                          <svg width="32" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <path d="m12.5 45.312h28.125c2.5898 0 4.6875 2.5898 4.6875 4.6875v37.5c0 2.5898-2.0977 4.6875-4.6875 4.6875h-28.125c-2.5898 0-4.6875-2.5898-4.6875-4.6875v-37.5c0-2.5898 2.0977-4.6875 4.6875-4.6875z"></path>  <path d="m12.5 7.8125h28.125c2.5898 0 4.6875 2.5898 4.6875 4.6875v18.75c0 2.5898-2.0977 4.6875-4.6875 4.6875h-28.125c-2.5898 0-4.6875-2.5898-4.6875-4.6875v-18.75c0-2.5898 2.0977-4.6875 4.6875-4.6875z"></path>  <path d="m59.375 64.062h28.125c2.5898 0 4.6875 2.5898 4.6875 4.6875v18.75c0 2.5898-2.0977 4.6875-4.6875 4.6875h-28.125c-2.5898 0-4.6875-2.5898-4.6875-4.6875v-18.75c0-2.5898 2.0977-4.6875 4.6875-4.6875z"></path>  <path d="m59.375 7.8125h28.125c2.5898 0 4.6875 2.5898 4.6875 4.6875v37.5c0 2.5898-2.0977 4.6875-4.6875 4.6875h-28.125c-2.5898 0-4.6875-2.5898-4.6875-4.6875v-37.5c0-2.5898 2.0977-4.6875 4.6875-4.6875z"></path> </svg>
                                          </i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div>   
            					</div>
                    </div>

                    {/* -------------------- */}
                      
                </div>
          </div>  
      </div>
      
    </div>
    );
  }
}


export default List;